module.exports = __webpack_public_path__ + "img/SAS_PaintedKiteShield.3b03b563.png";